import { render, staticRenderFns } from "./HeatmapLegendElement.vue?vue&type=template&id=2849002e"
import script from "./HeatmapLegendElement.vue?vue&type=script&lang=js"
export * from "./HeatmapLegendElement.vue?vue&type=script&lang=js"
import style0 from "./HeatmapLegendElement.vue?vue&type=style&index=0&id=2849002e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports